import React from 'react';
import Icon from '@/Components/UI/Icon/Icon';

const FilesDeletionWarning = ({ isExport = false }) => (
  <div className='flex justify-center'>
    <div className='flex items-center gap-2 border border-purple-200 bg-purple-50 text-sm text-gray-800 px-4 py-2 rounded-md w-fit max-w-full mb-4'>
      <Icon name='warning' color='#c084fc' />
      <span>
        {isExport ? 'Exports' : 'Files on the free plan'} are{' '}
        <strong>automatically deleted after 7 days</strong>.{' '}
        {!isExport && 'Upgrade now to retain your data.'}
      </span>
    </div>
  </div>
);

export default FilesDeletionWarning;
